import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { JobseekerService } from 'src/app/jobseeker/shared/services/jobseeker.service';
import { mergeMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import * as IndustryActions from './actions';

@Injectable()
export class IndustryEffects{

        loadIndustryList$ = createEffect(() => this.actions$.pipe(
            ofType(IndustryActions.getJobseekerIndustryList),
            mergeMap(() => this.jobseekerService.getIndustryList()
            .pipe(
                map(response => {
                    const industries = response.data
                    industries.forEach(industry => {
                        industry.childIndustryIds = industries.filter((cc) => cc.parentId == industry.id && cc.id != industry.id).map(cc => cc.id)
                    })
                    return IndustryActions.getJobseekerIndustryListSuccess({payload: industries})}
                ),
                catchError(response => of(IndustryActions.getJobseekerIndustryListFail({payload: response.error})))
            ))
        ));


    constructor(private actions$: Actions, private jobseekerService: JobseekerService){}
}